import { useQuery } from '@tanstack/react-query'
import api from '@/lib/api'
import type { Vehicle } from '@/types'

interface VehiclesResponse {
  data: Vehicle[]
}

export function useVehicles() {
  return useQuery({
    queryKey: ['customer', 'vehicles'],
    queryFn: async () => {
      const response = await api.get<VehiclesResponse>('/api/customer/vehicles')
      return response.data.data
    },
  })
}
